import { render } from "./FamilyRecordView.vue?vue&type=template&id=6a2f1b87"
import script from "./FamilyRecordView.vue?vue&type=script&lang=js"
export * from "./FamilyRecordView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__